/** @format */

import React, { useState, useEffect } from "react";
import { pageLoad } from "../../utils/GTMDataLayer";
import Spinner from "../Spinner/Spinner";
import { connect } from "react-redux";
import { logger } from "@goldenbird1/ui-logger-library";
import { v4 as uuidv4 } from "uuid";
function ShopNowWithoutAuth(props) {
  const [htmlContent, setHtmlContent] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    pageLoad("shop now page", "explore pages");
  },[]);
  useEffect(() => {
    function applyIframeStyles() {
      const iframe = document.getElementById('myIframe');
      if (iframe) {
        const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

        if (iframeDocument) {
          // Add styles to the iframe's document
          const style = iframeDocument.createElement('style');
          style.textContent = `
            html {
              overflow: hidden; /* Hide scrollbars on the html element */
            }

            body {
              height: 100%;
              margin: 0;
              scrollbar-width: none; /* Hide scrollbars in Firefox */
            }

            body::-webkit-scrollbar {
              display: none; /* Hide scrollbars in WebKit browsers (Chrome, Safari) */
            }
          `;
          iframeDocument.head.appendChild(style);
        }
        iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
      }
    }

    // Apply styles once iframe content is loaded
    const iframe = document.getElementById('myIframe');
    if (iframe) {
      iframe.addEventListener('load', applyIframeStyles);
    }

    //for adding dynamic url to the img or button onClick
    const handleIframeLoad = () => {
    };

    if (iframe) {
      iframe.addEventListener('load', handleIframeLoad);
    }

    // Cleanup event listener on component unmount
    return () => {
      if (iframe) {
        iframe.removeEventListener('load', applyIframeStyles);
      }
    };
  }, [htmlContent]);
  
  useEffect(() => {
    let buyerId = props.userProfile && props.userProfile?.userProfile?.profileId ? props.userProfile.userProfile.profileId : null;
    // let url =
    //   process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
    //   "/content/v1/ShopLanding-Guest";
    let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_URL + `/content/quraV2`;

    fetch(url, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN,
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw res.statusText || "COntent not found";
        }
      })
      .then((res) => {
        setHtmlContent(res.body);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        logger(
          "error",
          "Error from useEffect method ShopNow: " +
            url +
            ": buyerId =>  " +
            buyerId +
            ": error => " +
            error,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
      });
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <React.Fragment>
      {/* <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div> */}
      <div>
      <iframe
        id="myIframe"
          srcdoc={htmlContent}
          style={{width: "100%", height: "auto", border: "none",scrollBehavior:"unset"}}
        ></iframe>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    userProfile: state.userProfile
  };
};

export default connect(mapStateToProps, null)(ShopNowWithoutAuth);